/**
 *
 * Redux form is great!
 *     ...but it's got a few bugs and here are our tools to work around them until they get fixed.
 *
 */
import { forEach } from 'lodash';
import { change } from 'redux-form';

/**
 * Redux form does not currently have an action and reducer for changing multiple
 * fields at once. Long-term it would be good to add this either to redux-form
 * or as an action + plugin set, but the change logic is complicated enough and
 * currently in enough flux that my solution here is to just dispatch individual
 * change actions for each field in values.
 *
 * @param dispatch func
 * @param form string
 * @param values object
 * @param args
 */
export const multiChangeFormFields = (dispatch, form, values, ...args) => {
    forEach(values, (value, field) =>
        dispatch(change(form, field, value, ...args)),
    );
};
